module.exports = __webpack_public_path__ + "img/bin.85531b9b.svg";